
import logo from "../../img/logoMini.svg";
export default function Cargando() {
    return (
        <div style={{ "display": 'flex', 'justify-content': 'center', 'align-items': 'center', 'height': '100vh', 'flexDirection': 'column' }}>
            <img className="circle" src={logo} alt="Logo" />

            <h1>Cargando</h1>
        </div>
    );
}
